module.exports = __webpack_public_path__ + "img/cave.846250db.webp";